import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {PageLayoutComponent} from '@spartacus/storefront';

/**
 * This is a temporary fix for memory leak issue referenced here: https://github.com/SAP/spartacus/issues/16525
 */
@Component({
  // eslint-disable-next-line
  selector: 'cx-page-layout',
  templateUrl: './page-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DcpPageLayoutComponent extends PageLayoutComponent implements OnDestroy {
  ngOnDestroy(): void {
    this.section$.complete();
  }
}
